import { Component, OnInit, OnDestroy } from '@angular/core';
import { ConceptSearchListModel } from 'src/model/Concept/ConceptSearchListModel';
import { CoursewareService } from 'src/services/CoursewareService';
import { ActivatedRoute, Router } from '@angular/router';
import {catchError, debounceTime, distinctUntilChanged, tap, switchMap} from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AlertService } from '../_alert';
import { Error } from 'src/model/Error';
import { Title } from '@angular/platform-browser';
import { MetaService } from 'src/services/MetaService';
import { BaseComponent } from '../base.component';

let currentInstance = null;

@Component({
  selector: 'app-research-index',
  templateUrl: './research-index.component.html',
  styleUrls: ['./research-index.component.css']
})

export class ResearchIndexComponent  extends BaseComponent implements OnInit, OnDestroy {
  public alphabet: string[] = ["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"];
  public concepts: ConceptSearchListModel;
  retrievedData: boolean = false;
  public currentSearchTerm: string;
  navigationSubscription;
  lastSearchTerm = null;

  model: any;
  searching = false;
  searchFailed = false;  

  constructor(private canonicalService: MetaService, private _router: Router, private titleService: Title, private route: ActivatedRoute, private coursewareService: CoursewareService, private alertService: AlertService) { 
    super();
    this.titleService.setTitle("Research Index - LawShelf Educational Media");
    currentInstance = this;
//    this.navigationSubscription = this._router.events.subscribe((e: any) => {
//      if (e instanceof NavigationEnd) {
//          this.clearAnswers();
//      }
//    });
}

clearAnswers()
{
  this.currentSearchTerm = "";
  this.getResearchIndex(this.currentSearchTerm);
}

ngOnDestroy() {
  this.canonicalService.removeCanonicalURL();
  if (this.navigationSubscription) {  
     this.navigationSubscription.unsubscribe();
  }
}    

public getLetter(index: number)
{
  return this.alphabet[index];
}

  search = (text$: Observable<string>) =>
  text$.pipe(
    debounceTime(300),
    distinctUntilChanged(),
    tap(() => this.searching = true),
    switchMap(term =>
      this.coursewareService.getResearchIndexAutocomplete(term).pipe(
        tap(() => this.searchFailed = false),
        catchError(() => {
          this.searchFailed = true;
          return null;
          //return of([]);
        }))
    ),
    tap(() => this.searching = false)
  )

  resultFormatBandListValue(value: any) {            
    return value;
  } 
  /**
    * Initially binds the string value and then after selecting
    * an item by checking either for string or key/value object.
  */
  inputFormatBandListValue(value: any)   {
    this.currentSearchTerm = value;
    currentInstance.getResearchIndex(value);
    return value;
  }  

  public getRetrievedStyle()
  {
    if (!this.retrievedData)
      return "inline-block";
    return "none";
  }

  public searchForTerm(searchTerm: HTMLInputElement)
  {
    this.currentSearchTerm = searchTerm.value;
    this.getResearchIndex(searchTerm.value);
  }

  public getResearchIndex(searchString: string){
    this.currentSearchTerm = searchString;
    if (this.concepts)
      this.concepts.searchTerm = searchString;

    if (this.lastSearchTerm != null && this.lastSearchTerm == searchString){
      return;
    }
    this.lastSearchTerm = searchString;
    this.retrievedData = false;
    this.coursewareService.getResearchIndex(searchString, null).subscribe(data => {     
      let lastConcepts = this.concepts;
      this.concepts = data;
      this.retrievedData = true;
      this.pushAllAds(1);
      if (!this.concepts.concepts)
      {
        this.concepts = lastConcepts;
        let error: Error = data;
        this.alertService.error(error.Message);
        return;
      }
    });
  }

  public getMoreConcepts(searchString: string)
  {
    if (!this.concepts)
      return;
    let last = this.concepts.concepts.length - 1;
    this.retrievedData = false;
    this.coursewareService.getResearchIndex(this.concepts.searchTerm, this.concepts.concepts[last].Name).subscribe(data => {
      let lastConcepts = this.concepts;
      this.concepts = data;
      this.retrievedData = true;
      if (!this.concepts.concepts)
      {
        this.concepts = lastConcepts;
        let error: Error = data;
        this.alertService.error(error.Message);
        return;
      }
    });
  }

  ngOnInit() {
    this.currentSearchTerm = this.route.snapshot.paramMap.get('indexentry');
    if (!this.currentSearchTerm)
      this.currentSearchTerm =  this.route.snapshot.queryParams.startingLetter;
    if (!this.currentSearchTerm)
      this.currentSearchTerm = "";
    this.canonicalService.createCanonicalURL(this._router.url, "/researchindexview/" + this.currentSearchTerm);

    this.getResearchIndex(this.currentSearchTerm);
  }
}
